import {Component, HostBinding, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'ok-stamp',
    templateUrl: './ok-stamp.component.html',
    styleUrls: ['./ok-stamp.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class OkStampComponent {
    @HostBinding('class.visible')
    public showOkStamp = false;
}
